import React, { useEffect } from 'react';
import {RightOutlined} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useDispatch, useSelector} from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { getPickup } from 'redux/actions';
import {Skeleton} from "antd";

function OrderPickup({mode}) {
    const {theme:{direction, locale}, fetchedData:{pickups}} = useSelector(state => state)

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPickup());
    }, [])

    const setPickupAddress = (branch) => {
        localStorage.setItem("selected-mode", 'pickup')
        localStorage.setItem('selected-branch', JSON.stringify(branch))
    }

    if (mode !== 'pickup') return null

    return (
        <>
            <div style={{fontSize: '18px'}} className='order-mode__prev cursor-default pb-3 pt-2 mb-0 border-bottom'>Select Branch</div>
            {pickups.length === 0 ?
                <>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                </> :
                pickups.map(branch => <Link to={APP_PREFIX_PATH+(localStorage.getItem('fulfillment-time')===null? '/estimated-time' : '/menu')} key={branch?.id}>
                    <div className="menu-actions__item" onClick={() => setPickupAddress(branch)} >
                        <div>
                            <h4 className='menu-action__text mb-1'>{locale==='en' ? branch?.nameEng : branch?.nameAr} Branch</h4>
                            <Title className='mb-0' level={4} type="secondary">
                                {locale==='en' ? branch?.addressEng : branch?.addressAr}
                            </Title>
                        </div>
                        <RightOutlined rotate={ direction === DIR_RTL ? 180 : 0 } className='menu-action__icon m-0'/>
                    </div>
                </Link>)
            }
        </>
    );
}

export default OrderPickup;